// Les cartes de la fenêtre sont mémorisées par tâche : une même tâche doit garder le même objet tant que sa machine
// n'a pas changé, sinon chaque update-machine d'une autre machine redessinerait les 223 cartes.
const listsByMachine = new WeakMap();

const previewTasksOf = (machine) => {
    const cached = listsByMachine.get(machine)
    if (cached) {
        return cached
    }

    const summary = {
        id: machine.id,
        name: machine.name,
        number: machine.number,
        printingTechnique: machine.printingTechnique,
    }
    const list = (machine.tasks || [])
        .filter(task => task.previewUrl)
        .map(task => ({...task, machine: summary}))

    listsByMachine.set(machine, list)
    return list
}

export const buildPreviewTasks = (machines, machineId = null) => {
    if (machineId !== null && machineId !== undefined) {
        const machine = machines.find(item => item.id === machineId)
        return machine ? previewTasksOf(machine) : []
    }

    return machines.flatMap(previewTasksOf)
}

export const toggleId = (ids, id) => {
    return ids.includes(id) ? ids.filter(item => item !== id) : [...ids, id]
}
